// extracted by mini-css-extract-plugin
export default {"allContainers":"nav_allContainers__NC0Gt","mainContainer":"nav_mainContainer__wtRQQ","leftContainer":"nav_leftContainer__gTgCX","youtubeLogoIcon":"nav_youtubeLogoIcon__1sp5R"};